import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { ChatService } from "../chat.service";
import { Chat, Message, MessageData } from "../types";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@aihub/core/authorization";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";


@Component({
  selector: "app-conversation",
  templateUrl: "./conversation.component.html",
  styleUrls: ["./conversation.component.css"],
})
export class ConversationComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy{
  @Input() subscription_id: string = "";

  chat_logo = "assets/img/SRcircuitboard_lo.png";
  constructor(
    private chatService: ChatService,
    private route: ActivatedRoute,
    private router: Router,
    private readonly loginService: AuthService,
    private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  @ViewChild("messagefocus", { static: false }) messageTextarea: ElementRef;
  ngOnInit(): void {
    this.loginService
      .getJwtToken()
      // .pipe(takeUntil(this.destroy$))
      .subscribe((jwt: string) => {
        this.jwt = jwt;
      });
    this.route.queryParams.subscribe((params) => {
      this.stopLoading(); // stop loading message when leaving stream
      if (this.streamSubscription) {
        // stop stream when leaving chat
        this.streamSubscription.unsubscribe();
        this.streamSubscription = undefined;
      }
      this.conversation_id = params["conversation_id"] || "";
      if (this.conversation_id && this.loadChatOnQueryChange) {
        this.getChat(this.conversation_id);
      }
      if (!this.conversation_id) {
        this.messages = [];
      }
      this.loadChatOnQueryChange = true;
    });

    this.getImages();
  }

  getImages(): void {
      this.http.get("/assets/data/images.json").subscribe((res:any) => {
        this.chat_logo = res.chat_logo;
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(() => {
      this.messageTextarea.nativeElement.focus();
    });
  }

  ngAfterViewChecked() {
    if (this.dataRetrieved) {
      this.scrollDown();
      this.dataRetrieved = false;
    }
  }

  scrollDown(): void {
    const chatAreaDiv = document.getElementById("chat-area") as HTMLElement;
    chatAreaDiv.scrollTop = chatAreaDiv.scrollHeight;
  }

  createNewChat(): void {
    this.router.navigate(["/"], {
      queryParams: {
        conversation_id: null,
      },
      queryParamsHandling: "merge",
    });
    this.messages = [];
    this.conversation_id = "";
  }

  getChat(conversation_id: string): void {
    this.chatService
      .getChat(this.subscription_id, conversation_id)
      .subscribe((chat) => {
        this.messages = chat.messages.slice(1);
        this.dataRetrieved = true;
      });
  }

  startLoading(): void {
    this.isLoading = true;
    let waitingText = "";
    let dotCount = 0;
    this.dotCountInterval = setInterval(() => {
      // keep watingMessage empty if waitingText does not exist yet
      waitingText &&
        (this.waitingMessage =
          waitingText + Array(dotCount).fill(".").join(""));
      dotCount++;
      if (dotCount > 3) {
        dotCount = 0;
      }
    }, 500);
    this.waitingTimeout1 = setTimeout(() => {
      waitingText = "Preparing an answer, this might take some time";
      this.waitingMessage = waitingText + Array(dotCount).fill(".").join("");
      this.dataRetrieved = true;
    }, 600);
    this.waitingTimeout2 = setTimeout(() => {
      waitingText = "Still working on it, thank you for your patience";
      this.waitingMessage = waitingText + Array(dotCount).fill(".").join("");
    }, 15000);
  }

  stopLoading(): void {
    this.isLoading = false;
    this.waitingMessage = "";
    if (this.dotCountInterval) {
      clearInterval(this.dotCountInterval);
    }
    if (this.waitingTimeout1) {
      clearTimeout(this.waitingTimeout1);
    }
    if (this.waitingTimeout2) {
      clearTimeout(this.waitingTimeout2);
    }
  }

  jwt = "";
  private destroy$: Subject<boolean> = new Subject();
  streamSubscription: Subscription | undefined = undefined;
  isLoading = false;
  waitingMessage = "";
  loadChatOnQueryChange = true; // temporary fix for not reloading chat after query parameter update
  dotCountInterval = undefined;
  waitingTimeout1 = undefined;
  waitingTimeout2 = undefined;
  dataRetrieved = false;
  chats: Chat[] = [];
  messages: Message[] = [];
  prompt = "";
  conversation_id = "";
  sendMessage() {
    this.startLoading();
    const prompt = this.prompt;
    this.messages.push({
      content: prompt,
      role: "user",
      timestamp: undefined,
    });
    this.prompt = "";
    this.dataRetrieved = true;
    if (this.conversation_id) {
      this.updateChat(prompt);
    } else {
      this.addChat(prompt);
    }
  }
  updateChat(prompt: string): void {
    this.chatService
      .updateChat(this.subscription_id, this.conversation_id, prompt)
      .subscribe((chat) => {
        this.getChatStream(chat.conversation_id);
      });
  }
  addChat(prompt: string): void {
    this.chatService.addChat(this.subscription_id, prompt).subscribe((chat) => {
      this.getChatStream(chat.conversation_id);
    });
  }

  getChatStream(conversation_id: string) {
    this.streamSubscription = this.chatService
      .getChatStream(this.subscription_id, conversation_id, this.jwt)
      .subscribe((e: MessageData) => {
        if (this.messages[this.messages.length - 1].role === "user") {
          this.messages.push({
            role: "assistant",
            content: "",
            timestamp: undefined,
          });
        }
        if (e.message) {
          this.messages[this.messages.length - 1].content += e.message;
          this.changeDetectorRef.detectChanges();
          this.scrollDown();
        }
        if (e.error) {
          this.messages[this.messages.length - 1].content = e.error;
          this.changeDetectorRef.detectChanges();
          this.scrollDown();
          this.stopLoading();
        }
        if (e.finish_reason) {
          this.stopLoading();
        }
        if (e.status === "inserted" && !this.conversation_id) {
          // if new chat is created
          this.loadChatOnQueryChange = false;
          this.router.navigate(["/"], {
            queryParams: {
              conversation_id,
            },
            queryParamsHandling: "merge",
          });
        }
      });
  }
}
